module.exports = __webpack_public_path__ + "static/media/do.5d8caedb.svg";